// Purpose: Shopee integration API calls
// Caller: ShopeeItemPage, ShopeeOrderPage, ProductOutCreatePage, shopee util
// Dependencies: utils/xhr
// Main Functions: getShopeeItems, getShopeeOrders, getShopeeOrderDetail, updateShopeeStock, getShopeeItemModels, getShopeeCredentialOptions, updateShopeeItemSku, updateShopeeItemModels
// Side Effects: HTTP GET/POST to /shopee/* endpoints

import { xhr } from "utils";

export const getShopeeItems = (params) => xhr.get(`/shopee/item?${params}`);
export const getShopeeOrders = () => xhr.get("/shopee/order");
export const getShopeeOrderDetail = (barcode) =>
  xhr.get(`/shopee/order-detail/shopee-barcode/${barcode}`);
export const updateShopeeStock = (data) =>
  xhr.post("/shopee/item/update-stock", data);
export const getShopeeItemModels = (id, params = '') => xhr.get(`/shopee/item/${id}/models?${params}`);
export const getShopeeCredentialOptions = () => xhr.get('/credential/shopee-options');
export const updateShopeeItemSku = (itemId, params, data) => xhr.post(`/shopee/item/${itemId}?${params}`, data);
export const updateShopeeItemModels = (itemId, type, data) =>
  xhr.post(`/shopee/item/${itemId}/models?type=${type}`, data);
